import React, { useRef } from 'react';
import cn from 'classnames';
import CorporateForm from 'components/Forms/CorporateForm/CorporateForm';
import { ScrollContext } from 'utils/scroll';
import { observer, pricingCalculator as store } from 'store';
import { getAdditionalFormData } from '../../utils';
import { pushCustomEvent } from 'utils/analytics';
import * as styles from './FormStep.module.scss';

function FormStep({ id, className, onClose, resetFirstStep, steps }) {
  const scrollRootRef = useRef(null);

  const onSuccess = () => {
    pushCustomEvent('pricingMobile', { action: 'formSubmited', label: id });
    store.setStep(1);
    store.setPayload({});
    resetFirstStep();
  };
  const onResponse = () => {
    store.setIsSubmitting(false);
  };

  return (
    <div className={cn(styles.stepWrapper, className)}>
      <div className={styles.scrollArea} ref={scrollRootRef}>
        <ScrollContext.Provider value={scrollRootRef.current}>
          <CorporateForm
            id={id}
            formName={id}
            displaySubmitButton={false}
            closeModal={onClose}
            onSuccess={onSuccess}
            onResponse={onResponse}
            inModal={true}
            withNda={true}
            getAdditionalFormData={() => getAdditionalFormData(steps)}
          />
        </ScrollContext.Provider>
      </div>
    </div>
  );
}

export default observer(FormStep);
